export default __webpack_public_path__ + "img/service_none.388083ac8da4ae942ddabc7c51056233.jpg";